import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=1cdbc6f4&scoped=true&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"
import style0 from "./iframe.vue?vue&type=style&index=0&id=1cdbc6f4&scoped=true&lang=css&"
import style1 from "./iframe.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbc6f4",
  null
  
)

export default component.exports